export interface AppConfig {
    [key: string]: any;
}

export const config: AppConfig = window['config']
